// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG, PRODUCTION } from "common/config";
import { COMMON_JS } from "common/scripts";

export const USER_APIs = {
  getDriverDetails: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/us/v1/149G2899Z97542CP",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Add/Edit User Details
  manageUser: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/us/v1/114Z5894T27968ZR",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get user details
  getUsers: async (args = {}) => {
    let apiUrl = "/us/v1/912P8505F29771VN";
    if (PRODUCTION === "false") {
      apiUrl = "http://192.168.179.238:8003/us/v1/912P8505F29771VN";
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      PRODUCTION === "false"
    );
    return response;
  },

  // Get Usertype details
  getUserTypes: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/us/v1/736Z6674M27931IB",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },

  // Add/Edit
  manageAttendance: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/us/v1/XUNPM7746C5D5CMT",
      API_CONFIG.METHODS.POST,
      args
    );
    return response;
  },

  // Get
  getAttendance: async (args = {}) => {
    const response = await COMMON_JS.callApi(
      "/us/v1/O6BL092MCRJ36E9C",
      API_CONFIG.METHODS.GET,
      args
    );
    return response;
  },
};
